<template>
    <div class="nodata-box" :style="myStyle||''">
        暂无数据
    </div>
    <!-- 使用方法： -->
          <!-- <no-data v-else myStyle="color:#333;background:blue;"></no-data> -->
</template>
<script>
export default {
  props: {
    myStyle: {
      type: String,
      default: ''
    }

  }
}
</script>
<style lang="less">
.nodata-box{
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common-components/NoData.vue